import { render, staticRenderFns } from "./returnReports.vue?vue&type=template&id=6c90a8a7&scoped=true"
import script from "./returnReports.vue?vue&type=script&lang=js"
export * from "./returnReports.vue?vue&type=script&lang=js"
import style0 from "./returnReports.vue?vue&type=style&index=0&id=6c90a8a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c90a8a7",
  null
  
)

export default component.exports